import React, {useEffect, useState, Fragment} from 'react';
import PackagesList from '../../components/ui/PackagesList';
import flatstore from 'flatstore';
import Loader from '../../components/ui/Loader';
import {getRecipeInfo} from '../../utils/services';
import parse from 'html-react-parser';
import LoadModules from '../../components/ui/LoadModules'
import Image from '../../components/ui/Image'
import Meta from '../../components/ui/Meta';
import {currentLang} from '../../utils/functions';
import NotFound from '../static/404';
import W from '../../components/ui/Word';

const RecipeDetail = ({slug, loading, recipe_data, err_data}) => {
	const [data, setData] = useState(null);
	const [modules, setModules] = useState(0);
	
	let moduleData = {"relatedSlug":slug, "relatedType": "recipe"};
	
	useEffect(() => {

		if (loading === false && slug) {
			getRecipeInfo(slug);
			//console.log(recipe_data);
		}
		setData(recipe_data);
		
		if(recipe_data && recipe_data.modules !== null){
			setModules(recipe_data.modules);
		}

	}, [recipe_data]);

	useEffect(() => {
		//console.log(err_data);
	}, [err_data])
	
	if (loading) {
		return <Loader />
	} else {
		return (
			<Fragment>
			<LoadModules modules={modules} type="top" />
			{!data && err_data && err_data == '404' &&
				<NotFound />
			}
			{data &&
				<Fragment>
				<Meta
					title={data.seo_title ? data.seo_title : data.title}
					description={data.seo_description && data.seo_description}
					type="recipe"
					type_data={data}
					image={data.image_url}
				/>
				<div className="hero__section">
					<img className="hero__img" src={data.image_url} alt={data.title} />
				</div>
				<div className="recipe__desc">
				<div className="container">
					<div className="row recipe__title">
						<div className="col-md-12">
							{data.author && 
								<div className="author">
									<W>general.by</W> {data.author}
								</div>
							}
							<h1 className="heading heading--h2">{data.title}</h1>
						</div>
					</div>
					<div className="row">
						<div className="col-md-6 col-lg-4 col-xxl-3">
							<ul className="recipe__info">
								{data.prep_time && 
									<Fragment>
										<li className="fld"><W>recipes.prep_time</W></li>
										<li className="val">{data.prep_time} <W>minutes</W></li>
									</Fragment>
								}
								{data.cook_time && 
									<Fragment>
										<li className="fld"><W>recipes.cook_time</W></li>
										<li className="val">{data.cook_time} <W>minutes</W></li>
									</Fragment>
								}
								
								{data.portion_amount && 
									<Fragment>
										<li className="fld"><W>recipes.portion_amount</W></li>
										<li className="val">{data.portion_amount}</li>
									</Fragment>
								}
								{data.calories && 
									<Fragment>
										<li className="fld"><W>recipes.calories</W></li>
										<li className="val">{data.calories} kcal</li>
									</Fragment>
								}
							</ul>
							<p className="body">
								{data.body && parse(data.body)}
							</p>
						</div>
						<div className="col-md-5 offset-md-1 col-lg-7 col-xxl-8">
							{data.ingredients && data.ingredients.length > 0 && 
								<div className="recipe__ingredients">
									<h4 className="heading heading--h4"><W>recipes.ingredients</W></h4>
									<ul className="">
										{data.ingredients.map((item, index) => {
											return <li key={index}> {item.amount} {item.title && parse(item.title)} </li>
										})}
					
									</ul>
								</div>
							}
						</div>
					</div>
				</div>
				</div>
				{data.instructions && data.instructions.length > 0 &&
				<div className="pt-50 pb-50 bg--gray-light">
					<div className="container">
					<div className="row">
						<div className="col">
							<h2 className="golden--title text--center text--red display-2 mb-15"> <W>recipes.stepbystep</W></h2>
							
							<div className="row">
								{data.instructions.map((item, index) => {
									return (
										<div className="col-sm-6 col-md-6 col-lg-4" key={index}> 
											<div className="recipe__step">
												<div className="body">
													<h3 className="heading--h3"> <W>recipes.step</W> {index + 1}</h3>
													{item.body} 
												</div>
											</div>
										</div>
									)
								})}
							</div>
						</div>
						</div>
					</div>
				</div>
			}
		</Fragment>
		}
		
		<LoadModules modules={modules} moduleData={moduleData} type="bottom" />
		</Fragment>
		)
		
	}
	

}

export default flatstore.connect(['loading', 'recipe_data', 'err_data'])(RecipeDetail);